import { EShop } from '@containers/App/model';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { useIsDualPrice } from '../hooks/useIsDualPrice';
import { resolveVoucherDiscount } from '../ProductBaseInfo/VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../ProductBaseInfo/VoucherDiscount/utils';

import {
  getDiscountedVariantOffer,
  getVariantOffer,
  GetVariantOfferArgs,
  getVariantOffersByFilter,
} from './utils';

export const useVariantOffers = ({
  product,
  imageDomainPath,
  itemCountry,
  formatMessage,
}: Omit<GetVariantOfferArgs, 'variant'>) => {
  const { isDualPrice, getLeftSideFormattedPrice } = useIsDualPrice();
  const isBulgaria = useApolloClientHeaders().shopId === EShop.NOTINO_BG;

  const shouldAddDualCurrencyOffer = isBulgaria && isDualPrice;

  const discountedVariantOffers = getVariantOffersByFilter({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    offerCallback: getDiscountedVariantOffer,
    isBulgaria,

    filterCondition: (variant) => {
      const discount = resolveVoucherDiscount(variant);
      if (!discount) return false;
      if (isConditionalDiscount(discount)) {
        return (
          discount.discountConditions.length === 1 &&
          discount.discountConditions[0].productMeetsCondition
        );
      }
      return !!discount;
    },

    ...(shouldAddDualCurrencyOffer &&
      getLeftSideFormattedPrice && {
        convertToEur: getLeftSideFormattedPrice,
      }),
  });

  const variantOffers = getVariantOffersByFilter({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    offerCallback: getVariantOffer,
    isBulgaria,
    ...(shouldAddDualCurrencyOffer &&
      getLeftSideFormattedPrice && {
        convertToEur: getLeftSideFormattedPrice,
      }),
  });

  return { discountedVariantOffers, variantOffers };
};
